var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgNodatadashboard(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 126,
    height: 116,
    viewBox: "0 0 126 116",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_622",
    "data-name": "Rectangle 622",
    width: 126,
    height: 116,
    transform: "translate(-1338 850)",
    fill: "#fff",
    stroke: "#707070",
    strokeWidth: 1
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Mask_Group_2",
    "data-name": "Mask Group 2",
    transform: "translate(1338 -850)",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Medicine-rafiki_1_",
    "data-name": "Medicine-rafiki (1)",
    transform: "translate(-1347 795)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "freepik--background-complete--inject-22",
    transform: "translate(0 55)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_531",
    "data-name": "Rectangle 531",
    width: 145.835,
    height: 0.073,
    transform: "translate(0 95.493)",
    fill: "#ebebeb"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_532",
    "data-name": "Rectangle 532",
    width: 6.761,
    height: 0.073,
    transform: "translate(43.762 97.354)",
    fill: "#ebebeb"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_533",
    "data-name": "Rectangle 533",
    width: 16.529,
    height: 0.073,
    transform: "translate(117.28 98.917)",
    fill: "#ebebeb"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_534",
    "data-name": "Rectangle 534",
    width: 16.529,
    height: 0.073,
    transform: "translate(12.46 98.917)",
    fill: "#ebebeb"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_405",
    "data-name": "Path 405",
    d: "M96.191,137.484H39.873a1.665,1.665,0,0,1-1.663-1.665V56.651A1.665,1.665,0,0,1,39.873,55H96.191a1.665,1.665,0,0,1,1.665,1.665h0v79.153A1.665,1.665,0,0,1,96.191,137.484ZM39.873,55.058a1.593,1.593,0,0,0-1.59,1.593v79.168a1.592,1.592,0,0,0,1.59,1.592H96.191a1.6,1.6,0,0,0,1.593-1.592V56.651a1.6,1.6,0,0,0-1.593-1.593Z",
    transform: "translate(-27.065 -55)",
    fill: "#ebebeb"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_406",
    "data-name": "Path 406",
    d: "M312.487,137.484H256.165a1.671,1.671,0,0,1-1.665-1.665V56.651A1.668,1.668,0,0,1,256.165,55h56.321a1.665,1.665,0,0,1,1.66,1.651v79.168A1.663,1.663,0,0,1,312.487,137.484ZM256.165,55.058a1.6,1.6,0,0,0-1.593,1.593v79.168a1.6,1.6,0,0,0,1.593,1.592h56.321a1.6,1.6,0,0,0,1.593-1.592V56.651a1.6,1.6,0,0,0-1.593-1.593Z",
    transform: "translate(-180.27 -55)",
    fill: "#ebebeb"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_535",
    "data-name": "Rectangle 535",
    width: 41.058,
    height: 41.058,
    transform: "translate(21.406 54.434)",
    fill: "#e0e0e0"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_536",
    "data-name": "Rectangle 536",
    width: 37.707,
    height: 41.058,
    transform: "translate(17.471 54.434)",
    fill: "#ebebeb"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_537",
    "data-name": "Rectangle 537",
    width: 34.621,
    height: 11.212,
    transform: "translate(18.991 56.657)",
    fill: "#f5f5f5"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_538",
    "data-name": "Rectangle 538",
    width: 34.621,
    height: 11.212,
    transform: "translate(18.991 69.633)",
    fill: "#f5f5f5"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_539",
    "data-name": "Rectangle 539",
    width: 34.621,
    height: 11.212,
    transform: "translate(18.991 82.061)",
    fill: "#f5f5f5"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_407",
    "data-name": "Path 407",
    d: "M119.77,263.365a1.225,1.225,0,1,1-1.225-1.225A1.225,1.225,0,0,1,119.77,263.365Z",
    transform: "translate(-83.101 -201.724)",
    fill: "#fafafa"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_408",
    "data-name": "Path 408",
    d: "M120.29,349.555a.875.875,0,1,1-.875-.875A.875.875,0,0,1,120.29,349.555Z",
    transform: "translate(-83.965 -263.022)",
    fill: "#fafafa"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_409",
    "data-name": "Path 409",
    d: "M120.29,310.255a.875.875,0,1,1-.875-.875A.875.875,0,0,1,120.29,310.255Z",
    transform: "translate(-83.965 -235.185)",
    fill: "#fafafa"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_540",
    "data-name": "Rectangle 540",
    width: 47.735,
    height: 31.462,
    transform: "translate(19.863 3.993)",
    fill: "#e0e0e0"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_541",
    "data-name": "Rectangle 541",
    width: 47.735,
    height: 31.462,
    transform: "translate(18.941 3.993)",
    fill: "#f0f0f0"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_542",
    "data-name": "Rectangle 542",
    width: 44.608,
    height: 28.712,
    transform: "translate(20.312 5.492)",
    fill: "#fafafa"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_410",
    "data-name": "Path 410",
    d: "M173.936,75.23l-12.691,28.3H156.03l12.206-28.3Z",
    transform: "translate(-110.521 -69.33)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_411",
    "data-name": "Path 411",
    d: "M135.622,75.23l-12.889,28.3H116.62L130.1,75.23Z",
    transform: "translate(-82.605 -69.33)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_543",
    "data-name": "Rectangle 543",
    width: 48.592,
    height: 1.908,
    transform: "translate(18.941 3.993)",
    fill: "#e0e0e0"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_544",
    "data-name": "Rectangle 544",
    width: 48.592,
    height: 1.908,
    transform: "translate(18.941 6.393)",
    fill: "#e0e0e0"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_545",
    "data-name": "Rectangle 545",
    width: 48.592,
    height: 1.908,
    transform: "translate(18.941 8.794)",
    fill: "#e0e0e0"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_546",
    "data-name": "Rectangle 546",
    width: 48.592,
    height: 1.908,
    transform: "translate(18.941 11.191)",
    fill: "#e0e0e0"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_547",
    "data-name": "Rectangle 547",
    width: 48.592,
    height: 1.908,
    transform: "translate(18.941 13.592)",
    fill: "#e0e0e0"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_548",
    "data-name": "Rectangle 548",
    width: 51.083,
    height: 2.374,
    transform: "translate(17.9 35.455)",
    fill: "#e0e0e0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_412",
    "data-name": "Path 412",
    d: "M335.548,298.58v24.448h-8.639l-.461-2.447H292.88v-22Z",
    transform: "translate(-207.456 -227.535)",
    fill: "#e0e0e0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_413",
    "data-name": "Path 413",
    d: "M315.258,298.58v24.448h-2.721l-.461-2.447H277.84l-.543,2.447H272.59V298.58Z",
    transform: "translate(-193.084 -227.535)",
    fill: "#ebebeb"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_549",
    "data-name": "Rectangle 549",
    width: 38.095,
    height: 8.423,
    transform: "translate(81.673 72.76)",
    fill: "none",
    stroke: "#fafafa",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_550",
    "data-name": "Rectangle 550",
    width: 38.095,
    height: 8.508,
    transform: "translate(81.673 82.86)",
    fill: "none",
    stroke: "#fafafa",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_551",
    "data-name": "Rectangle 551",
    width: 17.13,
    height: 23.167,
    transform: "translate(110.196 2.75)",
    fill: "#e0e0e0"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_552",
    "data-name": "Rectangle 552",
    width: 17.13,
    height: 23.167,
    transform: "translate(109.338 2.736)",
    fill: "#e6e6e6"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_553",
    "data-name": "Rectangle 553",
    width: 15.383,
    height: 21.464,
    transform: "translate(110.196 3.605)",
    fill: "#fafafa"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_554",
    "data-name": "Rectangle 554",
    width: 11.757,
    height: 0.502,
    transform: "translate(112.252 20.411)",
    fill: "#e0e0e0"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_555",
    "data-name": "Rectangle 555",
    width: 11.757,
    height: 0.502,
    transform: "translate(112.252 21.691)",
    fill: "#e0e0e0"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_556",
    "data-name": "Rectangle 556",
    width: 11.757,
    height: 0.502,
    transform: "translate(112.252 22.972)",
    fill: "#e0e0e0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_414",
    "data-name": "Path 414",
    d: "M399.024,84.387a4.2,4.2,0,1,1-1.231-2.97A4.2,4.2,0,0,1,399.024,84.387Z",
    transform: "translate(-276.695 -72.843)",
    fill: "none",
    stroke: "#e0e0e0",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_557",
    "data-name": "Rectangle 557",
    width: 14.627,
    height: 14.627,
    transform: "translate(105.993 31.9)",
    fill: "#e0e0e0"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_558",
    "data-name": "Rectangle 558",
    width: 14.627,
    height: 14.627,
    transform: "translate(104.742 31.9)",
    fill: "#ebebeb"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_559",
    "data-name": "Rectangle 559",
    width: 12.606,
    height: 12.606,
    transform: "translate(105.754 32.912)",
    fill: "#fafafa"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_560",
    "data-name": "Rectangle 560",
    width: 6.685,
    height: 6.685,
    transform: "translate(108.714 35.87)",
    fill: "#e0e0e0"
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Shadow--inject-22",
    transform: "translate(23.602 163.627)"
  }, /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse_38",
    "data-name": "Ellipse 38",
    cx: 48.756,
    cy: 3.687,
    rx: 48.756,
    ry: 3.687,
    transform: "translate(0 0)",
    fill: "#f5f5f5"
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Box--inject-22",
    transform: "translate(28.869 131.202)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_561",
    "data-name": "Rectangle 561",
    width: 17.944,
    height: 20.251,
    transform: "translate(0 16.611)",
    fill: "#ce8045"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_562",
    "data-name": "Rectangle 562",
    width: 17.944,
    height: 20.251,
    transform: "translate(8.972 16.611)",
    fill: "#ce8045"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_563",
    "data-name": "Rectangle 563",
    width: 17.944,
    height: 20.251,
    transform: "translate(0 16.611)",
    fill: "#fff",
    opacity: 0.7
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_564",
    "data-name": "Rectangle 564",
    width: 8.989,
    height: 20.251,
    transform: "translate(17.923 16.611)",
    fill: "#fff",
    opacity: 0.2
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse_39",
    "data-name": "Ellipse 39",
    cx: 2.284,
    cy: 3.943,
    rx: 2.284,
    ry: 3.943,
    transform: "translate(19.763 22.948) rotate(-1.34)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_415",
    "data-name": "Path 415",
    d: "M172.807,402.038l-.974.023-.038-1.651-.752.017.038,1.651-1.07.026.029,1.286,1.07-.026L171.15,405l.753-.018-.038-1.636.974-.023Z",
    transform: "translate(-149.293 -375.866)",
    fill: "#ce8045"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_565",
    "data-name": "Rectangle 565",
    width: 3.634,
    height: 3.634,
    transform: "translate(7.522 16.611)",
    fill: "#f5f5f5"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_566",
    "data-name": "Rectangle 566",
    width: 3.634,
    height: 12.991,
    transform: "translate(7.522 23.87)",
    fill: "#f5f5f5"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_567",
    "data-name": "Rectangle 567",
    width: 14.721,
    height: 16.616,
    transform: "translate(8.972)",
    fill: "#ce8045"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_568",
    "data-name": "Rectangle 568",
    width: 14.721,
    height: 16.616,
    transform: "translate(16.334)",
    fill: "#ce8045"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_569",
    "data-name": "Rectangle 569",
    width: 12.425,
    height: 16.616,
    transform: "translate(8.972)",
    fill: "#fff",
    opacity: 0.7
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_570",
    "data-name": "Rectangle 570",
    width: 9.657,
    height: 16.616,
    transform: "translate(21.397)",
    fill: "#fff",
    opacity: 0.2
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_416",
    "data-name": "Path 416",
    d: "M186.211,337.176c.044,1.785-.761,3.255-1.8,3.278s-1.908-1.406-1.948-3.191.764-3.264,1.8-3.264S186.171,335.388,186.211,337.176Z",
    transform: "translate(-158.115 -328.826)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_417",
    "data-name": "Path 417",
    d: "M187.208,339.909l-.8.018-.032-1.356-.618.015.032,1.356-.881.02.026,1.056.878-.02.032,1.345.618-.018-.032-1.342.8-.018Z",
    transform: "translate(-159.847 -332.063)",
    fill: "#ce8045"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_571",
    "data-name": "Rectangle 571",
    width: 2.984,
    height: 16.616,
    transform: "translate(12.16)",
    fill: "#f5f5f5"
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Character--inject-22",
    transform: "translate(45.763 64.285)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_418",
    "data-name": "Path 418",
    d: "M226.932,236.04s-4.3,20.347-4.667,27.1,1.391,23.71,1.391,23.71l5.489.875,1.047-21.645,2.406-16.5s2.52,13.417,3.605,16.558,6.262,12.25,10.538,19.527l3.675-2.692s-6.869-19.641-8.041-23.477-.379-20.1-4-24.713Z",
    transform: "translate(-203.164 -191.629)",
    fill: "#ce8045"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_419",
    "data-name": "Path 419",
    d: "M226.932,236.04s-4.3,20.347-4.667,27.1,1.391,23.71,1.391,23.71l5.489.875,1.047-21.645,2.406-16.5s2.52,13.417,3.605,16.558,6.262,12.25,10.538,19.527l3.675-2.692s-6.869-19.641-8.041-23.477-.379-20.1-4-24.713Z",
    transform: "translate(-203.164 -191.629)",
    fill: "#fff",
    opacity: 0.4
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_420",
    "data-name": "Path 420",
    d: "M234.261,421.366a17.077,17.077,0,0,1-2.873-.455L231.2,418.1l-.076-1.1,2.917-.257s.05.84.1,1.8C234.2,419.8,234.293,421.27,234.261,421.366Z",
    transform: "translate(-209.472 -320.516)",
    fill: "#b55b52"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_421",
    "data-name": "Path 421",
    d: "M234.127,418.543,231.2,418.1l-.076-1.1,2.917-.257S234.075,417.58,234.127,418.543Z",
    transform: "translate(-209.472 -320.516)",
    opacity: 0.2
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_422",
    "data-name": "Path 422",
    d: "M222.75,428.926l-.117-.16c-.035-.05-.875-1.225-.752-1.8a.388.388,0,0,1,.2-.265.265.265,0,0,1,.274,0c.417.254.4,1.852.4,2.042Zm-.525-2.135a.187.187,0,0,0-.085.023.268.268,0,0,0-.131.178c-.09.4.382,1.167.613,1.523,0-.563-.076-1.549-.335-1.706a.117.117,0,0,0-.061-.017Z",
    transform: "translate(-202.919 -327.543)",
    fill: "#ce8045"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_423",
    "data-name": "Path 423",
    d: "M218.926,430.128l-.169-.07c-.181-.073-1.768-.735-1.867-1.3a.335.335,0,0,1,.12-.312.411.411,0,0,1,.362-.1c.642.111,1.435,1.563,1.458,1.625Zm-1.636-1.665a.268.268,0,0,0-.19.079.2.2,0,0,0-.079.193c.064.373,1.056.875,1.6,1.126-.227-.388-.817-1.31-1.277-1.391Z",
    transform: "translate(-199.39 -328.727)",
    fill: "#ce8045"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_424",
    "data-name": "Path 424",
    d: "M221.536,430.912l-2.946-.464a.744.744,0,0,0-.525.114,6.161,6.161,0,0,1-2.26.939c-1.26.178-2.38-.07-2.485.292a1.082,1.082,0,0,0,.543,1.222c.414.216,5.489,1,7.63,1.33a.747.747,0,0,0,.855-.808l-.184-1.954A.753.753,0,0,0,221.536,430.912Z",
    transform: "translate(-196.84 -330.22)",
    fill: "#222221"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_425",
    "data-name": "Path 425",
    d: "M224.67,410.98l.461,2.427,6.008.572.178-2.456Z",
    transform: "translate(-204.904 -316.436)",
    fill: "#ce8045"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_426",
    "data-name": "Path 426",
    d: "M312.681,402a16.9,16.9,0,0,1-2.532,1.432l-1.733-1.9-.907-1,.922-.875,1.2-1.129s.123.14.324.362l1.062,1.2C311.8,400.97,312.64,401.924,312.681,402Z",
    transform: "translate(-263.582 -307.611)",
    fill: "#b55b52"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_427",
    "data-name": "Path 427",
    d: "M311.013,400.959l-2.6,1.444-.907-1,.922-.875,1.52-.767Z",
    transform: "translate(-263.582 -308.489)",
    opacity: 0.2
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_428",
    "data-name": "Path 428",
    d: "M309.722,415.392l-.152-.07c-.055-.023-1.336-.61-1.458-1.126a.324.324,0,0,1,.082-.292.359.359,0,0,1,.335-.134c.519.085,1.059,1.33,1.12,1.473Zm-1.24-1.5a.233.233,0,0,0-.181.093.2.2,0,0,0-.05.184c.07.327.793.747,1.21.957-.2-.432-.615-1.167-.945-1.231Z",
    transform: "translate(-264.003 -318.41)",
    fill: "#ce8045"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_429",
    "data-name": "Path 429",
    d: "M304.971,418.744a1.109,1.109,0,0,1-.744-.19.414.414,0,0,1-.1-.432.583.583,0,0,1,.341-.408c.761-.344,2.462.522,2.535.56l.146.076L307,418.4A9.019,9.019,0,0,1,304.971,418.744Zm-.055-.98a.954.954,0,0,0-.391.07.455.455,0,0,0-.265.321.292.292,0,0,0,.058.292c.35.338,1.776.044,2.473-.143A5.744,5.744,0,0,0,304.916,417.764Z",
    transform: "translate(-261.171 -321.149)",
    fill: "#ce8045"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_430",
    "data-name": "Path 430",
    d: "M310.319,409.841l-2.6,1.458a.729.729,0,0,0-.341.414,6.125,6.125,0,0,1-1.19,2.138c-.875.925-1.908,1.426-1.765,1.773a1.076,1.076,0,0,0,1.181.621c.458-.087,4.926-2.625,6.808-3.693a.747.747,0,0,0,.166-1.167l-1.356-1.42a.753.753,0,0,0-.907-.125Z",
    transform: "translate(-261.389 -315.56)",
    fill: "#222221"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_431",
    "data-name": "Path 431",
    d: "M298.9,395.948l1.87,1.622,5.066-3.284-1.385-2.036Z",
    transform: "translate(-257.483 -303.169)",
    fill: "#ce8045"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_432",
    "data-name": "Path 432",
    d: "M256.2,151.8a23.547,23.547,0,0,1,6.708.432c3.208.674-2.508,4.62-2.508,4.62l-1.791,7.169-3.281.029-.4-10.179Z",
    transform: "translate(-226.338 -132.796)",
    fill: "#ebebeb"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_433",
    "data-name": "Path 433",
    d: "M241.13,152.214,234.171,163.2l.77-11.515a22.633,22.633,0,0,0-3.313.292c-.785.228-1.458,2.059-2.021,4.568s-1.418,8.523-1.418,8.523l-4,33.542s13.671,2.917,20.111.65c0,0-2.421-30.127-2.021-31.987s1.692-8.668,1.692-8.668,1.791-3.4,1.012-4.4S241.13,152.214,241.13,152.214Z",
    transform: "translate(-204.564 -132.767)",
    fill: "#ce8045"
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_126",
    "data-name": "Line 126",
    x2: 0.992,
    y2: 26.618,
    transform: "translate(28.362 40.576)",
    fill: "none",
    stroke: "#fff",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 0.75
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_572",
    "data-name": "Rectangle 572",
    width: 25.489,
    height: 18.836,
    transform: "translate(3.391 27.999) rotate(-18.82)",
    fill: "#ce8045"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_434",
    "data-name": "Path 434",
    d: "M184.416,150.914l-18.051,26.052-3.389-1.537L156.9,157.6l24.127-8.222Z",
    transform: "translate(-156.9 -131.137)",
    fill: "#ce8045"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_435",
    "data-name": "Path 435",
    d: "M184.416,150.914l-24.127,8.222,6.075,17.83-3.389-1.537L156.9,157.6l24.127-8.222Z",
    transform: "translate(-156.9 -131.137)",
    fill: "#fff",
    opacity: 0.7
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_573",
    "data-name": "Rectangle 573",
    width: 25.489,
    height: 18.836,
    transform: "translate(3.391 27.999) rotate(-18.82)",
    fill: "#fff",
    opacity: 0.46
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_40",
    "data-name": "Ellipse 40",
    cx: 6.805,
    cy: 6.805,
    r: 6.805,
    transform: "matrix(0.774, -0.633, 0.633, 0.774, 8.471, 31.854)",
    fill: "#fafafa"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_436",
    "data-name": "Path 436",
    d: "M213.428,186.827l-2.774.907-.893-2.724-2.144.7.893,2.724-3.051,1,.691,2.12,3.054-1,.884,2.7,2.144-.7-.884-2.7,2.774-.907Z",
    transform: "translate(-191.297 -156.375)",
    fill: "#ce8045"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_437",
    "data-name": "Path 437",
    d: "M261,91.59V87.346a8.464,8.464,0,0,1,9.088,2.179l-2.042,4.118Z",
    transform: "translate(-230.637 -86.834)",
    fill: "#ce8045"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_574",
    "data-name": "Rectangle 574",
    width: 0.537,
    height: 1.642,
    transform: "translate(34.299 1.03) rotate(11.17)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_575",
    "data-name": "Rectangle 575",
    width: 0.537,
    height: 1.642,
    transform: "translate(33.552 1.989) rotate(-78.83)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_438",
    "data-name": "Path 438",
    d: "M261.028,110.875c-.849,1.222-1.628,1.053-1.628,1.053a4.667,4.667,0,0,1-.983,1.234c-.14,3.812.983,4.842.983,4.842-1.167,1.8-2.608,1.75-4.066,1.225a2.091,2.091,0,0,1-1.534-1.668,1.884,1.884,0,0,0,1.146-2.357,3.065,3.065,0,0,0-.333-.764c-2.476-.68-3.191-3.054-3.022-5.294a12.107,12.107,0,0,1,.986-3.938L254.037,103l5.7,1.167.306,3.022-1.167,2.24C260.935,107.909,261.886,109.638,261.028,110.875Z",
    transform: "translate(-223.957 -98.285)",
    fill: "#b55b52"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_439",
    "data-name": "Path 439",
    d: "M259.789,127.211a2.742,2.742,0,0,1-.414-.029.1.1,0,0,1,.035-.2,2.114,2.114,0,0,0,2.085-.825.1.1,0,0,1,.178.1A2.1,2.1,0,0,1,259.789,127.211Z",
    transform: "translate(-229.426 -114.65)",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_440",
    "data-name": "Path 440",
    d: "M257.165,120.811c.061,0,.309-1.861.309-1.861l-1.324,1.593A1.167,1.167,0,0,0,257.165,120.811Z",
    transform: "translate(-227.202 -109.583)",
    fill: "#a02724"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_441",
    "data-name": "Path 441",
    d: "M265.383,117.964c-.032.23-.175.4-.318.382s-.233-.225-.2-.455.175-.405.318-.385S265.416,117.731,265.383,117.964Z",
    transform: "translate(-233.37 -108.559)",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_442",
    "data-name": "Path 442",
    d: "M255.723,117.091c-.032.23-.175.4-.318.382s-.233-.222-.2-.455.175-.4.318-.382S255.77,116.858,255.723,117.091Z",
    transform: "translate(-226.527 -107.943)",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_443",
    "data-name": "Path 443",
    d: "M267.818,113.087a.137.137,0,0,1-.122-.079c-.347-.738-.837-.642-.858-.639a.137.137,0,0,1-.064-.265c.029,0,.723-.163,1.167.787a.137.137,0,0,1-.067.184A.131.131,0,0,1,267.818,113.087Z",
    transform: "translate(-234.661 -104.726)",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_444",
    "data-name": "Path 444",
    d: "M253.6,111.927a.131.131,0,0,1-.093-.038.134.134,0,0,1,0-.193,1.738,1.738,0,0,1,1.8-.44.137.137,0,0,1,.079.178.14.14,0,0,1-.181.076,1.474,1.474,0,0,0-1.5.376A.128.128,0,0,1,253.6,111.927Z",
    transform: "translate(-225.304 -104.056)",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_445",
    "data-name": "Path 445",
    d: "M263.3,141.69a2.581,2.581,0,0,1-.93.9,3.06,3.06,0,0,0-.332-.764A3.1,3.1,0,0,0,263.3,141.69Z",
    transform: "translate(-231.374 -125.69)",
    opacity: 0.2
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_446",
    "data-name": "Path 446",
    d: "M258.677,99.512s-4.92,1.315-6.881.618-1.275-3.106-1.009-3.334c.362-.309,1.149.968,1.149.968s-.645-1.368-.14-1.668.583,1.75,2.421,1.534,6.93-1.6,7.231,1.6a11.375,11.375,0,0,1-.9,5.618s-.271-1.75-2.438-.359a.742.742,0,0,1,0-1.219C259.363,102.05,258.925,100.443,258.677,99.512Z",
    transform: "translate(-223.166 -93.374)",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_447",
    "data-name": "Path 447",
    d: "M276.3,106.051s-.855,2.794.717,2.66.607-3.051.607-3.051Z",
    transform: "translate(-241.308 -100.169)",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_448",
    "data-name": "Path 448",
    d: "M260.73,98.508s-1.027-.755-.764-1.3.671.776,2.715.534,4.471-.426,4.92.93-4.083.324-4.083.324l-2.794.6Z",
    transform: "translate(-229.874 -94.084)",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_449",
    "data-name": "Path 449",
    d: "M250.219,215.087l-1.975-.557s-2.333-.143-2.529.747-.292,2.424.636,2.546a34.36,34.36,0,0,0,3.815-.058Z",
    transform: "translate(-219.719 -177.279)",
    fill: "#b55b52"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_450",
    "data-name": "Path 450",
    d: "M267.258,163.1l3.182-2.841s3.94,8.75,4.162,12.113-2.377,4.874-4.579,5.44-9.5,2.074-9.5,2.074l-.394-4.06s7.773-1.327,10.766-2.7C270.884,173.134,268.192,165.3,267.258,163.1Z",
    transform: "translate(-230.021 -138.844)",
    fill: "#ce8045"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_451",
    "data-name": "Path 451",
    d: "M261.48,223.762l7.356-1.572.02,1.108Z",
    transform: "translate(-230.977 -182.711)",
    opacity: 0.1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_452",
    "data-name": "Path 452",
    d: "M264.5,150.968l.837,2.211a23.713,23.713,0,0,0,3.652-3.328l-1.213-2.021A7.389,7.389,0,0,1,264.5,150.968Z",
    transform: "translate(-233.116 -130.039)",
    fill: "#fafafa"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_453",
    "data-name": "Path 453",
    d: "M258.563,150.3a5.732,5.732,0,0,0,.613,2.418l-.913,2.042a4.436,4.436,0,0,1-1.254-3.59Z",
    transform: "translate(-227.792 -131.789)",
    fill: "#fafafa"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNodatadashboard);
export default __webpack_public_path__ + "static/media/nodatadashboard.404a013ec8395e14975632ed00351cbe.svg";
export { ForwardRef as ReactComponent };